import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { RenderMenuNode } from './menu.types';

export interface SideMenuState {
  tree: RenderMenuNode[];
  loading: boolean;
}

export const createInitialState = (): SideMenuState => ({
  tree: [],
  loading: false,
});

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'side-menu' })
export class SideMenuStore extends Store<SideMenuState> {
  constructor() {
    super(createInitialState());
  }
}
